import React from "react";
import {
  announcementsCreate,
  announcements,
  announcementsList
} from "../../routes/LearningCenterRoutes";
import AnnouncementsList from "../../views/Announcements/AnnouncementsList";
import AnnouncementsNew from "../../views/Announcements/AnnouncementsNew";
import { Route, Redirect } from "react-router-dom";

const LearningCenterAnnouncements = () => {
  return (
    <>
      <Route
        exact
        path={announcements}
        render={() => <Redirect to={announcementsList} />}
      />
      <Route exact path={announcementsList} component={AnnouncementsList} />
      <Route exact path={announcementsCreate} component={AnnouncementsNew} />
    </>
  );
};

export default LearningCenterAnnouncements;
